import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import API_URL from '../../config/api';

const ModelSelection = ({ productionLine, onSelect }) => {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchModels = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/models/?production_line=${productionLine.id}`
      );
      const activeModels = (response.data.results || response.data).filter(model => model.is_active);
      setModels(activeModels);
      setLoading(false);
    } catch (error) {
      console.error('Erreur:', error);
      setLoading(false);
    }
  }, [productionLine]);

  useEffect(() => {
    fetchModels();
  }, [fetchModels]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <div className="loading-spinner h-12 w-12 mx-auto mb-4"></div>
          <p className="text-gray-600 font-medium">Chargement des modèles...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto animate-fade-in">
      <div className="text-center mb-8 sm:mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold text-corporate-900 mb-2 sm:mb-3">
          Chaîne: {productionLine.name}
        </h2>
        <h3 className="text-xl sm:text-2xl text-gray-600 font-medium">Sélectionnez le modèle</h3>
      </div>

      {models.length === 0 ? (
        <div className="text-center py-16 sm:py-20">
          <div className="text-6xl sm:text-8xl mb-4 sm:mb-6">📦</div>
          <p className="text-gray-600 text-lg sm:text-2xl font-semibold">Aucun modèle disponible</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
          {models.map((model, index) => (
            <button
              key={model.id}
              onClick={() => onSelect(model)}
              className="card-hover p-4 sm:p-6 min-h-[240px] sm:min-h-[280px] flex flex-col items-center
                       animate-fade-in"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              {model.image_url ? (
                <div className="relative w-full h-40 sm:h-48 mb-3 sm:mb-4 rounded-lg overflow-hidden bg-gray-100">
                  <img
                    src={model.image_url}
                    alt={model.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              ) : (
                <div className="w-full h-40 sm:h-48 mb-3 sm:mb-4 rounded-lg bg-gray-100 flex items-center justify-center text-5xl sm:text-6xl">
                  📦
                </div>
              )}
              
              <div className="text-base sm:text-lg font-bold text-corporate-900 text-center">
                {model.name}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ModelSelection;
